const BTN_CLASS = '.js-share-link';

const copyToClipboard = (function () {
    let DOM = {};

    let cache = function () {
        DOM.elntsClips = document.querySelectorAll(BTN_CLASS);
    };

    let bindEvents = function () {
        DOM.elntsClips.forEach(function (e) {
            e.addEventListener('click', clipbHandler);
        });
    };

    let clipbHandler = function (e) {
        let target = e.currentTarget;
        let clipbData = target.dataset.clipboard;

        if (target.nodeName === 'A') {
            e.preventDefault();
        }

        copyTextToClipboard(clipbData, popup.pop.bind(this, 'копирано', target));
    };

    let fallbackCopyTextToClipboard = function (text, callback) {
        let textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            callback();
        } catch (e) {
            console.error(e);
        }

        document.body.removeChild(textarea);
    };

    let copyTextToClipboard = function (text, callback) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text, callback);
            return;
        }

        navigator.clipboard
            .writeText(text)
            .then(function () {
                callback();
            })
            .catch(function (e) {
                console.error(e);
            });
    };

    let popup = (function () {
        let popBox = document.createElement('div');
        let active = false;
        let clear = 0;
        popBox.classList.add('cb-popup');

        return {
            pop: function (message, node) {
                popBox.innerHTML = message;

                if (!active) {
                    node.parentNode.appendChild(popBox);
                    active = true;
                }

                if (clear) {
                    clearTimeout(clear);
                }

                clear = setTimeout(function () {
                    let node = document.querySelector('.cb-popup');
                    node.parentNode.removeChild(node);
                    active = false;
                }, 800);
            },
        };
    })();

    return {
        init: function () {
            cache();
            if (!DOM.elntsClips) {
                return;
            }
            bindEvents();
        },
    };
})();

copyToClipboard.init();
